import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { Offcanvas } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Loading from "../../components/UI/Loading";

const MainCanvas = ({ children, show, onClose, title }) => {
  return (
    <Offcanvas
      show={show}
      placement="end"
      onHide={onClose}
      className="my-canvas"
    >
      <Offcanvas.Header closeButton className="pb-2">
        <Offcanvas.Title className="m-0 p-0">{title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="pt-0">{children}</Offcanvas.Body>
    </Offcanvas>
  );
};

export default MainCanvas;
